export const BRAND_NAME = "0xLegion";